import { Component, OnInit } from '@angular/core';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsTenant} from '../../../models/sts-tenant.model';
import {StsHttpService} from '../../../services/sts-http.service';
import { StsRootConfigObject } from 'app/models/sts-account-config.model';

@Component({
  selector: 'app-sts-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  tenantInfo: StsTenant = new StsTenant();
  config: StsRootConfigObject = new StsRootConfigObject();

  constructor(private tenantService: StsTenantService,
              private http: StsHttpService) { }

  ngOnInit() {
    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;
    });
    this.tenantService.getConfigSource().subscribe(cfg => {
      this.config = cfg;
    });
  }

  getLocale(s): string {
    return s.toString().split(/-/)[0].toUpperCase();
  }

  setLocale(s) {
    this.http.get('/api/locale/set?lang=' + s).subscribe(a => {
      document.defaultView.location.reload();
    });
    return false;
  }

}
